export default function googleMapsHelper($window) {
  return {
    getApiUrl: getApiUrl,
    setLatLng: setLatLng,
  };

  function getApiUrl() {
    return '//maps.googleapis.com/maps/api/js?key=' + $window.ENVIRONMENT.GOOGLE_MAPS_KEY + '&libraries=places&callback=initMap';
  }

  function setLatLng(e, merchant) {
    if (e && e.latLng) {
      merchant.latitude = e.latLng.lat().toFixed(6);
      merchant.longitude = e.latLng.lng().toFixed(6);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/googleMaps.helper.js